import i18n from 'src/i18n'
import { Wrapper } from './communitiesErrorState.styles'

const CommunitiesErrorState = () => {
  return (
    <Wrapper className="_d-flex _justify-content-center _align-items-center _text-center _px-5 _py-6">
      <p className="_text-1 _text-gray-600 _mb-0 _font-14">
        {i18n.t('profile.user_info.error_state.message')}
      </p>
    </Wrapper>
  )
}

export default CommunitiesErrorState
